<!-- Mold Yönü Seçimi -->
<div class="ui horizontal divider header"
     style="margin-top: 0.1rem;margin-bottom:0.5rem;color: white;text-transform: unset;font-size:0.8rem;">
    Mold Yönü:
</div>

<!-- Yüzey Seçim Durumu -->
<div *ngIf="yonSecimAktif"
     style="margin-bottom: 0.5rem;padding: 0.5rem;background: #fff9c4;border-radius: 4px;font-size: 0.75rem;color: #333;">
    <strong>💡:</strong> Yüzeye tıkla
</div>

<!-- Seçili Yön Bilgisi -->
<div *ngIf="!yonSecimAktif && secilenFaceNormal"
     style="margin-bottom: 0.5rem;padding: 0.5rem;background: #c8e6c9;border-radius: 4px;font-size: 0.7rem;color: #333;">
    <div><strong>✓ Yüzey:</strong> ({{ secilenFaceNormal.x.toFixed(4) }}, {{ secilenFaceNormal.y.toFixed(4) }}, {{ secilenFaceNormal.z.toFixed(4) }})</div>
    <button (click)="resetYuzeySecimi()"
            class="ui mini button"
            style="width:100%;margin-top:3px;padding:4px 8px;font-size:11px;">
        Seçimi Sıfırla
    </button>
</div>

<!-- Eksen Butonları ve Yön Seç -->
<div style="display: flex;justify-content: space-between;margin-bottom: 0.5rem;gap: 2px;">
    <button class="ui mini button"
            [class.primary]="moldDirection.x > 0.5 && !secilenFaceNormal"
            (click)="moldYonunuGuncelle('x')"
            [disabled]="yonSecimAktif"
            style="flex:1;padding:0.4rem;">
        <i class="arrows alternate horizontal icon"></i>
    </button>
    <button class="ui mini button"
            [class.primary]="moldDirection.y > 0.5 && !secilenFaceNormal"
            (click)="moldYonunuGuncelle('y')"
            [disabled]="yonSecimAktif"
            style="flex:1;padding:0.4rem;">
        <i class="arrows alternate vertical icon"></i>
    </button>
    <button class="ui mini button"
            [class.primary]="moldDirection.z > 0.5 && !secilenFaceNormal"
            (click)="moldYonunuGuncelle('z')"
            [disabled]="yonSecimAktif"
            style="flex:1;padding:0.4rem;">
        <i class="long arrow alternate up icon"></i>
    </button>
    <button class="ui mini button"
            [class.teal]="yonSecimAktif"
            (click)="yonSec()"
            [disabled]="yonSecimAktif"
            style="flex:2;padding:0.4rem;">
        <i class="hand pointer icon"></i> Yön Seç
    </button>
</div>

<!-- Açı Aralıkları Yönetimi -->
<div class="ui horizontal divider header"
     style="margin-top: 0.5rem;margin-bottom:0.5rem;color: white;text-transform: unset;font-size:0.8rem;">
    Açı Aralıkları ({{ aciAraliklarListesi.length }}/10)
</div>

<!-- Mevcut Aralıklar Listesi -->
<div style="max-height: 200px;overflow-y: auto;margin-bottom: 0.5rem;background: rgba(0,0,0,0.2);border-radius: 4px;padding: 0.3rem;">
    <div *ngFor="let aralik of aciAraliklarListesi; let i = index"
         style="margin-bottom: 0.3rem;padding: 0.3rem;background: rgba(255,255,255,0.05);border-radius: 3px;">
        <div style="display:flex;gap:4px;align-items:center;margin-bottom:3px;">
            <input type="text"
                   [(ngModel)]="aralik.isim"
                   (change)="aralikDegisti()"
                   placeholder="İsim"
                   style="flex:1;padding:2px 4px;font-size:0.65rem;background:rgba(0,0,0,0.3);color:#fff;border:1px solid #666;border-radius:2px;">
            <input type="color"
                   [(ngModel)]="aralik.renk"
                   (change)="aralikDegisti()"
                   style="width:30px;height:20px;cursor:pointer;border:1px solid #666;border-radius:2px;">
            <button class="ui mini icon button negative"
                    (click)="aralikSil(i)"
                    style="padding:4px 6px;font-size:0.6rem;">
                <i class="trash icon" style="margin:0;"></i>
            </button>
        </div>
        <div style="display:flex;gap:4px;align-items:center;">
            <div style="flex:1;">
                <label style="font-size:0.6rem;color:#aaa;">Min:</label>
                <input type="number"
                       [(ngModel)]="aralik.min"
                       (change)="aralikDegisti()"
                       min="-180"
                       max="180"
                       step="0.1"
                       style="width:100%;padding:2px 4px;font-size:0.65rem;background:rgba(0,0,0,0.3);color:#fff;border:1px solid #666;border-radius:2px;">
            </div>
            <div style="flex:1;">
                <label style="font-size:0.6rem;color:#aaa;">Max:</label>
                <input type="number"
                       [(ngModel)]="aralik.max"
                       (change)="aralikDegisti()"
                       min="-180"
                       max="180"
                       step="0.1"
                       style="width:100%;padding:2px 4px;font-size:0.65rem;background:rgba(0,0,0,0.3);color:#fff;border:1px solid #666;border-radius:2px;">
            </div>
            <div style="flex:1;text-align:center;font-size:0.65rem;color:#aaa;">
                {{ (aralik.max - aralik.min).toFixed(1) }}°
            </div>
        </div>
    </div>
</div>

<!-- Yeni Aralık Ekle -->
<div style="margin-bottom: 0.5rem;padding: 0.3rem;background: rgba(33, 186, 69, 0.1);border-radius: 4px;border:1px dashed rgba(33, 186, 69, 0.5);">
    <div style="font-size:0.7rem;margin-bottom:4px;color:#4caf50;">+ Yeni Aralık</div>
    <div style="display:flex;gap:4px;align-items:center;margin-bottom:3px;">
        <input type="text"
               [(ngModel)]="yeniAralik.isim"
               placeholder="Aralık İsmi"
               style="flex:1;padding:2px 4px;font-size:0.65rem;background:rgba(0,0,0,0.3);color:#fff;border:1px solid #666;border-radius:2px;">
        <input type="color"
               [(ngModel)]="yeniAralik.renk"
               style="width:30px;height:20px;cursor:pointer;border:1px solid #666;border-radius:2px;">
    </div>
    <div style="display:flex;gap:4px;align-items:center;margin-bottom:3px;">
        <input type="number"
               [(ngModel)]="yeniAralik.min"
               placeholder="Min (-180°)"
               min="-180"
               max="180"
               step="0.1"
               style="flex:1;padding:2px 4px;font-size:0.65rem;background:rgba(0,0,0,0.3);color:#fff;border:1px solid #666;border-radius:2px;">
        <span style="font-size:0.6rem;color:#aaa;">-</span>
        <input type="number"
               [(ngModel)]="yeniAralik.max"
               placeholder="Max (+180°)"
               min="-180"
               max="180"
               step="0.1"
               style="flex:1;padding:2px 4px;font-size:0.65rem;background:rgba(0,0,0,0.3);color:#fff;border:1px solid #666;border-radius:2px;">
    </div>
    <button class="ui mini button green fluid"
            (click)="aralikEkle()"
            [disabled]="aciAraliklarListesi.length >= 10"
            style="padding:4px 8px;font-size:0.7rem;">
        <i class="plus icon"></i> Ekle
    </button>
</div>

<!-- Kontrol Butonları -->
<div class="ui horizontal divider header"
     style="margin-top: 0.5rem;margin-bottom:0.5rem;color: white;text-transform: unset;font-size:0.8rem;">
    Kontrol:
</div>
<div style="display: flex;justify-content: space-between;">
    <button class="ui icon mini green button"
            [disabled]="analizAktif"
            (click)="analiziBaslat()"
            style="flex:1;margin-right:5px;">
        <i class="play icon"></i>
        Başlat
    </button>
    <button class="ui icon mini red button"
            [disabled]="!analizAktif"
            (click)="analiziDurdur()"
            style="flex:1;margin-left:5px;">
        <i class="stop icon"></i>
        Durdur
    </button>
</div>

<!-- Durum -->
<div style="margin-top: 0.5rem;text-align: center;">
    <span style="font-size: 0.8rem;"
          [class.text-success]="analizAktif"
          [class.text-warning]="!analizAktif">
        <i [class]="analizAktif ? 'check circle icon' : 'pause circle icon'"></i>
        {{ analizAktif ? 'Analiz Aktif' : 'Analiz Pasif' }}
    </span>
</div>

<!-- B-Rep yüz-bazlı sayısal rapor (analitik normal — CATIA feasibility) -->
<button class="ui icon mini blue button fluid" style="margin-top:0.6rem;" (click)="brepDraftRaporuOlustur()">
    <i class="table icon"></i> B-Rep Yüz Raporu (Analitik)
</button>
@if (brepRapor) {
    <div style="margin-top:0.5rem;font-size:0.78rem;border:1px solid rgba(120,160,255,.25);border-radius:8px;padding:8px;">
        <div style="display:flex;justify-content:space-between;margin-bottom:4px;">
            <b>Toplam yüz</b><span>{{ brepRapor.toplam }}</span>
        </div>
        <div style="display:flex;justify-content:space-between;margin-bottom:6px;"
             [style.color]="brepRapor.minDraftDeg < 0.5 ? '#ff7043' : ''">
            <b>En küçük draft</b><span>{{ brepRapor.minDraftDeg }}°</span>
        </div>
        @for (g of brepRapor.gruplar; track g.isim) {
            <div style="display:flex;align-items:center;gap:6px;margin:2px 0;">
                <span style="width:12px;height:12px;border-radius:2px;display:inline-block;" [style.background]="g.renk"></span>
                <span style="flex:1;" [style.color]="g.ters ? '#ff5555' : ''">{{ g.isim }}</span>
                <b>{{ g.sayi }}</b>
            </div>
        }
    </div>
}
